import {
  useRef,
} from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Chip, Typography } from '@mui/material';
import { GrayAutocompleteArrayInputWithUpperLabel } from './GrayAutocompleteArrayInputWithUpperLabel';
import { type AssigneeChoice } from '../../../../utils/certifiedUsersAssignments';

const AssigneeOptionText = () => {

  const record = useRecordContext<AssigneeChoice>();
  const translate = useTranslate();
  if (!record) return null;

  if (record.type === 'group') {

    return (
      <Box>
        {record.name}
        <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
          ({translate('resources.groups.text.members', { smart_count: record.membersCount })})
        </Typography>
        <Chip label={translate('menu.items.groups')} variant="outlined" color="primary" size="small" sx={{ ml: 1 }} />
      </Box>
    );

  }
  return <span>{record.name}</span>;

};

const getChoiceLabel = (choice: AssigneeChoice) => {

  if (choice.type === 'group') {

    return `${choice.name} (${choice.membersCount})`;

  }
  return choice.name;

};

export const CertifiedUsersSelectionInput = (props: {
  label: string;
  helperText?: string;
  choices: AssigneeChoice[];
  disabled?: boolean;
}) => {

  const choices = props.choices;
  const choicesRef = useRef(choices);
  choicesRef.current = choices;

  const formatSelection = (selectedIds: string[] | undefined): string[] => selectedIds ?? [];

  const parseSelection = (selectedIds: string[] | undefined):
   string[] => (selectedIds ?? []).filter((id) => choicesRef.current.some((choice) => choice.id === id));

  return (
    <GrayAutocompleteArrayInputWithUpperLabel
      source="recipientChoiceIds"
      disabled={props.disabled}
      label={props.label}
      helperText={props.helperText}
      choices={choices}
      optionValue="id"
      optionText={<AssigneeOptionText />}
      inputText={(choice: AssigneeChoice) => getChoiceLabel(choice)}
      matchSuggestion={(filter, choice: AssigneeChoice) => getChoiceLabel(choice).toLowerCase().includes(filter.toLowerCase())}
      format={formatSelection}
      parse={parseSelection}
      renderTags={(value, getTagProps) => (value as AssigneeChoice[]).map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={option.id}
          label={getChoiceLabel(option)}
          size="small"
        />
      ))}
      fullWidth
    />
  );

};
